<template>
  <div @click="handleClick">
    <el-button type="primary" plain :disabled="DISABLED.BTN">{{ BTN_CONTENT }}</el-button>
  </div>
</template>

<script>
import {toRefs, reactive, computed, onUnmounted} from 'vue'
import {timer} from '../config/component.config'
import { useI18n } from "../plugins/i18n";


export default {
  name: 'sr-timer-btn',
  props: {
    duration: {
      type: Number,
      default: timer.duration.code
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  setup(props) {
    const { t } = useI18n()
    const state = reactive({
      timer: null,
      duration: props.duration,
    })

    const scopedComputed = {
      BTN_CONTENT: computed(() => {
        return state.timer ? `${t('user.register.content.text_6')}（${state.duration}）` : t('user.register.content.text_1')
      }),
      DISABLED: computed(() => {
        return {
          BTN: (function () {
            return props.disabled || !!state.timer
          })()
        }
      })
    }

    const scopedMethods = {
      handleClick: (e) => {
        if (state.timer) {
          console.log('stop!')
          e.stopPropagation()
        }
      },
      startTimer: () => {
        scopedMethods.clearTimer()
        scopedMethods.setTimer()
      },
      setTimer: () => {
        state.timer = setInterval(() => {
          state.duration--
          if (state.duration === 0) {
            scopedMethods.clearTimer()
          }
        }, timer.millisecond)
      },
      clearTimer: () => {
        clearInterval(state.timer)

        state.timer = null
        state.duration = props.duration
      }
    }

    onUnmounted(() => {
      scopedMethods.clearTimer()
    })

    return {
      ...toRefs(state),
      ...scopedComputed,
      ...scopedMethods
    }
  }
}
</script>

<style scoped>

</style>
